import BookPage from '../../book/page';
export default function Page() { return <BookPage lang="en" />; }
